import React from 'react';
import * as Icons from '@material-ui/icons';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import XLRLogger from '../../helpers/logger';

export type IconType = typeof import('@material-ui/icons/index');

export const MuiIcon: React.FC<Props> = (props: Props): JSX.Element => {
  const { iconKey, ...rest } = props;

  if (!Icons[iconKey]) {
    XLRLogger.info({
      message: `Couldn't find ${iconKey} in MaterialUI Icons Index`,
      data: { iconKey },
      source: 'mui-icon.tsx',
    });
  }

  return React.createElement(Icons[iconKey] || Icons.ErrorSharp, { ...rest });
};

interface Props extends SvgIconProps {
  iconKey: string | keyof IconType;
}
